var _path, _path2, _circle, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 17.6458C13.75 18.3751 13.4602 19.0746 12.9445 19.5903C12.4288 20.106 11.7293 20.3958 11 20.3958C10.2707 20.3958 9.57119 20.106 9.05547 19.5903C8.53974 19.0746 8.25 18.3751 8.25 17.6458",
    stroke: "#686B6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11588 16.7293C4.66722 16.634 4.27055 16.3742 4.00412 16.0008C3.73769 15.6275 3.62088 15.1678 3.67674 14.7126L4.5934 7.27843C4.82745 5.75003 5.60549 4.35751 6.78445 3.35709C7.9634 2.35666 9.46395 1.81561 11.0101 1.83343C12.5562 1.81561 14.0567 2.35666 15.2356 3.35709C16.4147 4.35751 17.1927 5.75003 17.4268 7.27843L18.3434 14.7126C18.3996 15.1666 18.284 15.6251 18.0195 15.9982C17.7549 16.3713 17.3604 16.6321 16.9134 16.7293C13.0337 17.6409 8.99555 17.6409 5.11588 16.7293Z",
    stroke: "#686B6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 6,
    r: 6,
    fill: "url(#paint0_linear_20_165)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.85 7.55H13.31V7.08L16.47 1.85H18.14V6.56H19.1V7.55H18.14V9H16.85V7.55ZM16.87 6.56V2.86L14.73 6.56H16.87Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_165",
    x1: 10,
    y1: 0,
    x2: 24.4688,
    y2: 5.47113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158668,
    stopColor: "#F76A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60652,
    stopColor: "#A24AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891362,
    stopColor: "#4859F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.fd8a4910e04c8f082f6423b407c9cff9.svg";
export { ForwardRef as ReactComponent };